/**
 * Interface định nghĩa năng lực (capabilities) của một kênh chat.
 * UI (Component) trên màn hình sẽ KHÔNG được chứa các lệnh If/Else liên quan tới Zalo/Facebook, 
 * mà chỉ dựa vào biến này để quyết định việc ẩn/hiện Nút bấm hay tính năng tương ứng.
 */
export interface IChannelCapabilities {
    canSendImage: boolean;         // Hỗ trợ gửi ảnh
    canSendFile: boolean;          // Hỗ trợ gửi file (.pdf, .docx,...)
    canSendSticker: boolean;       // Hỗ trợ sticker (Của nền tảng Zalo, Facebook)
    canSendProduct: boolean;       // Hỗ trợ gửi sản phẩm Ecom (Shopee, Lazada, Tiktok)
    canSendVoucher: boolean;       // Hỗ trợ gửi mã giảm giá (Tiktok)
    canSendOrder: boolean;         // Hỗ trợ tạo và gửi thông tin đơn hàng
    canPrivateReply: boolean;      // Hỗ trợ tính năng "Nhắn tin phản hồi bình luận"
    canMention: boolean;           // Hỗ trợ gửi @tag (Zalo Group cá nhân)
    canVoiceRecord: boolean;       // Hỗ trợ ghi âm lời nói và gửi (Audio)
    canSendTemplate: boolean;      // Hỗ trợ gửi template/utility message có key-value
    canManageReactions: boolean;   // Hỗ trợ thêm/xóa reaction/emote trên tin nhắn
    canRevoke?: boolean;           // Hỗ trợ thu hồi tin nhắn (Zalo/Facebook)
    canHideComment?: boolean;      // Hỗ trợ ẩn bình luận (Facebook)
    canLikeComment?: boolean;      // Hỗ trợ like bình luận (Facebook)
    canPinMessage?: boolean;       // Hỗ trợ ghim tin nhắn/bình luận
    
    maxLength: number;             // Giới hạn ký tự tối đa của 1 tin nhắn Text
    supportedFileExtensions: string[]; // Danh sách các đuôi file hỗ trợ riêng của kênh
}

// Chuyển toàn bộ các enum cấu hình từ db/config cũ vào đây
export const CHANNEL_MAP = {
    FACEBOOK: 1,
    INSTAGRAM: 2,
    SHOPEE: 4,
    ZALO: 5,
    LAZADA: 6,
    TELEGRAM: 7,
    WHATSAPP: 8,
    TIKTOK: 9,
    ZALO_PERSONAL: 10,
};
